var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerLeft1"}},[_vm._m(0),_c('dv-scroll-board',{staticClass:"scroll-board",staticStyle:{"width":"100%","height":"200px"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"text"},[_vm._v("认养人区域流向")])])
}]

export { render, staticRenderFns }